import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
} from "reactstrap";

/**
 * EditRoomModal - Modal for editing an existing room.
 * Props:
 *   isOpen: bool
 *   room: the room being edited (editingRoom)
 *   roomData: { name, roomTypeId } (editRoomData)
 *   onRoomDataChange: (updatedData) => void
 *   onSave: () => void
 *   onCancel: () => void
 *   loading: bool (updatingRoom)
 *   roomTypes: array
 *   loadingRoomTypes: bool
 */
const EditRoomModal = ({
  isOpen,
  roomData,
  onRoomDataChange,
  onSave,
  onCancel,
  loading,
  roomTypes,
  loadingRoomTypes,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={onCancel} size="sm">
      <ModalHeader toggle={onCancel}>Edit Room</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="editRoomName">
            Room Name <span className="text-danger">*</span>
          </Label>
          <Input
            id="editRoomName"
            type="text"
            placeholder="Enter room name"
            value={roomData.name}
            onChange={(e) => onRoomDataChange({ ...roomData, name: e.target.value })}
            disabled={loading}
          />
        </FormGroup>
        <FormGroup>
          <Label for="editRoomType">Room Type</Label>
          <Input
            id="editRoomType"
            type="select"
            value={roomData.roomTypeId || ""}
            onChange={(e) => onRoomDataChange({ ...roomData, roomTypeId: e.target.value })}
            disabled={loading || loadingRoomTypes}
          >
            <option value="">{loadingRoomTypes ? "Loading..." : "No Room Type"}</option>
            {roomTypes.map((rt) => (
              <option key={rt.id} value={rt.id}>
                {rt.name}
              </option>
            ))}
          </Input>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onCancel} disabled={loading}>
          Cancel
        </Button>
        <Button color="primary" onClick={onSave} disabled={loading}>
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2"></span>
              Updating...
            </>
          ) : (
            "Update Room"
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditRoomModal;
